/**
 * @class
 * @classdesc Exception type for service-side errors.
 *
 * @property {Number} code - Error code
 * @property {String} message - Error description
 */
class SessionError extends Error {

  public code: number;

  constructor(message: string, code: number) {
    super();

    this.name = this.constructor.name;
    this.message = message;
    this.code = code;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = (new Error()).stack;
    }
  }
}

export { SessionError };
